import { useTranslation } from "react-i18next";
import { AdminGate } from "../../components/admin/AdminGate";
import adminStyles from "../../components/admin/Admin.module.css";
import { ApproverRequests } from "../../components/requests/ApproverRequests";

const ApproveAnyPermission = "request.approve.any";

/**
 * The "Requests" screen: every request, pending or completed, as the approver's table (who, what, when, assigned to) with
 * Approve, Reject (reason required) and Reassign (pick another approver) per row. Gated on `request.approve.any`: an approver
 * without it sees only the requests assigned to them, in the "Waiting for my decision" section of My Requests.
 */
export function RequestsPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={adminStyles.usersPage}>
      <AdminGate permissions={[ApproveAnyPermission]} title={t("admin.requests.denied.title")} description={t("admin.requests.denied.description")}>
        <ApproverRequests />
      </AdminGate>
    </div>
  );
}
